import React, { useEffect } from "react";
import { Checkbox, FormControlLabel, Grid, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { Controller, useFormContext } from "react-hook-form";

import { SubTitle } from "../index";
import { watch } from "fs";

const useStyles = makeStyles(() => ({
  firstRow: {
    marginTop: 14,
  },
  optionForklift: {
    marginTop: -14,
  },
}));

const OptionForklift = () => {
  const { control, setValue } = useFormContext();
  const name = "optionForklift";

  return (
    <Controller // control 로 감싸줘야 form 에서 데이터를 가져감
      control={control}
      name={name}
      defaultValue={watch("optionForklift")}
      render={({ field }) => (
        <FormControlLabel
          control={
            <Checkbox
              {...field}
              onChange={(e: any) => {
                const val = e.target.checked;
                field.onChange(e);
                setValue(name, val); // DOM API 가 string 으로 컨버팅 하기 때문에 값을 다시 넣어준다.
              }}
              color="primary"
            />
          }
          label="지게차 운전 가능한 기사님"
        />
      )}
    />
  );
};

const RequestNoteField = (props: any) => {
  const classes = useStyles();

  const { name, title, placeholder, text } = props;

  const { register, setValue } = useFormContext();

  useEffect(() => {
    setValue(name, text);
  }, [setValue, text]);

  return (
    <Grid item className={classes.firstRow}>
      <TextField
        {...register(name)}
        variant="outlined"
        defaultValue={""}
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{
          maxLength: 150,
        }}
        label={title}
        multiline={true}
        maxRows={2}
        placeholder={placeholder}
        fullWidth
        onFocus={() => {
          console.log(
            `운송주문-${
              name === "requestNoteForDriver"
                ? "기사님요청사항 작성"
                : "운영자요청사항 작성"
            } 시작`
          );
          window.gtag(
            "event",
            `운송주문-${
              name === "requestNoteForDriver"
                ? "기사님요청사항 작성"
                : "운영자요청사항 작성"
            } 시작`,
            {
              user_id: localStorage.getItem("customerName") || "none",
            }
          );
        }}
        onBlur={() => {
          console.log(
            `운송주문-${
              name === "requestNoteForDriver"
                ? "기사님요청사항 작성"
                : "운영자요청사항 작성"
            } 종료`
          );
          window.gtag(
            "event",
            `운송주문-${
              name === "requestNoteForDriver"
                ? "기사님요청사항 작성"
                : "운영자요청사항 작성"
            } 종료`,
            {
              user_id: localStorage.getItem("customerName") || "none",
            }
          );
        }}
      />
      <br />
      <br />
    </Grid>
  );
};

export default function RequestNote(props: any) {
  const { requestNoteForDriver, requestNoteForAdmin } = props;

  return (
    <>
      <SubTitle>{"요청사항"}</SubTitle>
      <Grid container direction={"column"}>
        <Grid item>
          <RequestNoteField
            name={"requestNoteForDriver"}
            title={"기사님 요청사항"}
            placeholder={"입구에서 연락주세요."}
            text={requestNoteForDriver}
          />
        </Grid>
        <Grid item>
          <RequestNoteField
            name={"requestNoteForAdmin"}
            title={"카고콜 요청사항"}
            placeholder={"상차 앞뒤 1시간 여유있어요."}
            text={requestNoteForAdmin}
          />
        </Grid>
        {/*<Grid item className={classes.optionForklift}>*/}
        {/*  <OptionForklift/>*/}
        {/*</Grid>*/}
      </Grid>
    </>
  );
}
